function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1163 9.22308C18.1163 8.07047 17.8893 6.92921 17.4482 5.86424C17.0071 4.79948 16.3607 3.83179 15.5456 3.01689C14.7306 2.20176 13.7631 1.55528 12.6982 1.11429C11.6333 0.67309 10.492 0.446167 9.33942 0.446167V2.20155C10.2615 2.20155 11.1745 2.38326 12.0264 2.73597C12.8783 3.08888 13.6524 3.60616 14.3044 4.25821C14.9564 4.91005 15.4736 5.68425 15.8265 6.53601C16.1793 7.38799 16.3609 8.30104 16.3609 9.22308H18.1163Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.5625 7.4677V3.07924C0.5625 2.59454 0.955463 2.20155 1.44019 2.20155H5.82865C6.31338 2.20155 6.70634 2.59454 6.70634 3.07924V6.59001C6.70634 7.07471 6.31338 7.4677 5.82865 7.4677H4.07327C4.07327 11.3455 7.21692 14.4892 11.0948 14.4892V12.7338C11.0948 12.2491 11.4878 11.8562 11.9725 11.8562H15.4833C15.968 11.8562 16.3609 12.2491 16.3609 12.7338V17.1223C16.3609 17.607 15.968 18 15.4833 18H11.0948C5.27798 18 0.5625 13.2845 0.5625 7.4677Z",
  fill: "#4979C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.2047 7.20778C14.4694 7.84676 14.6056 8.5316 14.6056 9.22308H13.0257C13.0257 8.73902 12.9304 8.25968 12.7451 7.81248C12.5599 7.36506 12.2883 6.95878 11.946 6.61658C11.6037 6.27416 11.1974 6.00267 10.7501 5.81731C10.3029 5.63218 9.8235 5.53682 9.33942 5.53682V3.95693C10.031 3.95693 10.7158 4.09322 11.3547 4.35785C11.9936 4.62249 12.5741 5.01033 13.0632 5.49932C13.5522 5.98831 13.9401 6.56879 14.2047 7.20778Z",
  fill: "#4979C0"
});

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.882e944f.svg";
export { ForwardRef as ReactComponent };